import { create } from 'zustand';

const useConfigStore = create((set) => ({
  // State
  config: {}, // ytConfig
  mapConfig: {},
  crmConfig: {},
  featureFlags: null,

  // Actions
  setConfig: (config) => set({ config }),
  setMapConfig: (mapConfig) => set({ mapConfig }),
  setCrmConfig: (crmConfig) => set({ crmConfig }),
  setFeatureFlags: (featureFlags) => set({ featureFlags }),

  // Bulk update from community data
  setCommunityConfig: (communityData, processedFeatureFlags) => set({
    config: communityData?.yt || {},
    mapConfig: communityData?.map || {},
    crmConfig: communityData?.crm || {},
    featureFlags: processedFeatureFlags,
  }),
}));

export default useConfigStore;
